export default "__VITE_ASSET__f2cdc82e__"